"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATE_ACUTE_WASTE_CODES = void 0;
exports.STATE_ACUTE_WASTE_CODES = {
    IN: {
        /**
         * Indiana's six chemical munitions, all under I001: 329 IAC 3.1-6-3. The VX
         * carve-out in 3.1-6-3(c) can't be told apart by code, so VX waste is held
         * acute too (over-strict).
         */
        codes: ["I001"],
        citation: "329 IAC 3.1-6-3(a)-(b)",
    },
    MI: {
        /** Michigan's "severely toxic hazardous waste": R 299.9219 Table 202. */
        codes: ["001S", "002S", "003S", "004S", "005S", "006S", "007S"],
        citation: "Mich. Admin. Code R 299.9304, 299.9305(1), 299.9212, 299.9219",
    },
};
//# sourceMappingURL=stateAcuteWasteCodes.js.map